<template>
  <div class="footer-container">
      <div class="footer">
          <div class="footer-links">
               <div class="contact-info">
                    <img src="@/assets/common/icon_logo.png" srcset="@/assets/common/icon_logo@2x.png 2x" class="footer-msg-logo" alt="logo">
                    <div class="contact-info__item cursor" @click="openAMap(contactData.address)">
                      <img src="@/assets/footer/icon_address.png" srcset="@/assets/footer/icon_address@2x.png 2x" />
                      {{ contactData.address }}
                    </div>
                    <div class="contact-info__item cursor" @click="callPhone(contactData.phone)">
                      <img src="@/assets/footer/icon_phone.png" srcset="@/assets/footer/icon_phone@2x.png 2x" />
                      {{ contactData.phone }}
                    </div>
                    <div class="contact-info__item">
                      <img src="@/assets/footer/icon_email.png" srcset="@/assets/footer/icon_email@2x.png 2x" />
                      <div>
                        <div class="cursor" v-for="value in contactData.email?.split(' ')"  @click="sendEmail(value)">
                          {{ value }}
                        </div>
                      </div>
                    </div>
                    <!-- <div class="contact-info__item">
                      <img src="@/assets/footer/icon_email2.png" srcset="@/assets/footer/icon_email2@2x.png 2x" />
                        {{ contactData.email }}
                    </div> -->
              </div> 
              <div class="contact-info">
                <div class="contact-info__title">{{ contactData.title_legal_terms }}</div>
                    <div class="contact-info__item cursor" @click="handleClick(contactData.privacyPolicy)">
                      {{ contactData.title_privacy_policy }}
                    </div>
                    <div class="contact-info__item cursor" @click="handleClick(contactData.termsOfService)">
                      {{ contactData.title_terms_of_service }}
                    </div>
                    <div class="contact-info__item cursor" @click="handleClick(contactData.copyright)">
                      {{ contactData.title_copyright }}
                    </div>
                    <div class="contact-info__item cursor" @click="handleClick(contactData.cookiePolicy)">
                      {{ contactData.title_cookie_policy }}
                    </div>
              </div>
              <div class="contact-info">
                  <div class="contact-info__title">{{ contactData.title_aboutus }}</div>
                  <div class="flex">
                      <div class="contact-info__qr">
                        <img :src="contactData.wechat_qrcode_image_url" alt="微信二维码">
                        <div class="contact-info__desc">{{ contactData.title_wechat }}</div>
                      </div>
                      <div class="contact-info__qr">
                        <img :src="contactData.website_qrcode_image_url"  alt="微博二维码">
                        <div class="contact-info__desc">{{ contactData.title_mobileweb }}</div>
                      </div>
                  </div>
              </div>
          </div>
        <p class="copyright">{{ lang.copyright }}</p>
      </div>
  </div>
   
</template>

<script setup>
    import { ref } from 'vue';
    import { useRouter } from 'vue-router'
    const router = useRouter()
    
    // 语言包
    const language = localStorage.getItem("language") || "zh"
    const lang = ref({})
    import(`@/language/${language}.js`).then(data => {
        lang.value = data.default.footer
    })  

  defineProps({
      contactData: { type: Object }
  })

   // 点击跳转
    const handleClick = (path) => {
        router.push({ path })
    }

    // 调起拨打电话
    const callPhone = (phoneNumber) => {
      window.location.href = `tel:${phoneNumber}`;
    }

    // 点击按钮时调起邮件客户端并填写收件人地址
    const sendEmail = (emailRecipient) => {
        window.location.href = `mailto:${emailRecipient}`;
    }

    // 点击按钮时打开高德地图
    const openAMap = (address) => {
        // 中环中心经纬度  114.02847,22.528362
        window.open(`https://ditu.amap.com/search?query=${encodeURIComponent(address)}&city=440300&geoobj=114.022768%7C22.524556%7C114.037606%7C22.532465&zoom=17`, '_blank');
        
    }
        
</script>

<style lang="scss" scoped>
       .footer-container {
          font-family: 'PingFangSC-regular';
          background-color: #F8FAFC;
          font-weight: 400;
          font-size: 20px;
       }

       .footer-msg-logo {
          margin-bottom: 20px;
       }

       .footer {
            height: 488px;
            width: 1200px;
            margin: 0 auto;
            padding: 53px 0 24px 0;
            box-sizing: border-box;
        }
        .footer-links {
            display: flex;
            justify-content: space-between;
        }
        .contact-info__title {
            color: #333333;
            font-weight: 500;
            font-size: 24px;
            letter-spacing: 2px;
            margin-bottom: 46px;
            line-height: 33px;
            height: 44px;
        }
        .contact-info__item {
            color: #666666;
            font-weight: 400;
            font-size: 20px;
            letter-spacing: 2px;
            margin: 20px  0;
            min-width: 180px;
            max-width: 460px;
        }
        .contact-info__item {
            display: flex;
            align-items: center;
        }

        .contact-info__qr {
          margin: 0 30px 30px 0;
        }
        .contact-info__qr img{
            width: 180px;
            height: 180px;
        }
        .contact-info__item img {
          margin-right: 21px;
        }
        .contact-info__desc {
          text-align: center;
          color: #1753A3;
          font-weight: 400;
          font-size: 20px;
          margin-top: 26px;
        }
        
        .copyright{
          color: #999999;
          font-weight: 400;
          font-size: 18px;
          text-align: center;
        }

        .flex {
          display: flex;
        }

        .cursor{
          cursor: pointer;
        }

        .cursor:hover{
          color: #333333;
          text-decoration: underline;
        }

        /* 响应式布局 */
        @media (max-width: 768px) {
            .footer {
              padding: 24px 16px;
              height: auto;
              width: 100%;
            }
            
            .footer-links{
              display: block;
              margin-bottom: 24px;
            }

            .footer-msg-logo {
               width: 204px;
               height:20px;
               margin-bottom: 6px;
            }

            .footer-msg{
              margin-bottom: 24px;
            }

            .contact-info__title {
                font-family: PingFangSC-medium;
                color: #333333;
                font-weight: 500;
                font-size: 18px;
                width: 100%;
                margin-left: 0px;
                margin-bottom: 6px;
                height: 24px;
                line-height: 24px;
            }

            .contact-info__item {
                color: #666666;
                font-weight: 400;
                font-size: 14px;
                letter-spacing: 1px;
                margin: 6px 0;
                min-width: 180px;
                max-width: 90%;

                img {
                  width: 16px;
                  height: 16px;
                  margin-right: 8px;
                }
          }

            .contact-info__qr{
                margin: 8px;

                img {
                  width: 80px;
                  height: 80px;
                  margin-right: 0;
                }
            }

            .contact-info__desc {
              font-family: PingFangSC-regular;
              color: #1753A3;
              font-weight: 400;
              font-size: 12px;
              margin-top: 4px;
          }
          .contact-info {
            margin-bottom: 24px;
          }
          
          .copyright {
            font-family: Inter-regular;
            color: #999999;
            font-weight: 400;
            font-size: 12px;
            padding-bottom: 38px;
          }

          .flex {
            display: flex;
            justify-content: center;
          }
        }
</style>